import { get, post } from './http-calls';

export const getCustomStyle = async () => {
    let res = await get(`CustomStyle/GetStyle`, { useAuthToken: true });
    return res;
};

export const postCustomStyle = async (data) => {
    let res = await post(`CustomStyle/UploadStyle`, data, { useAuthToken: true });
    return res;
};